import { render, staticRenderFns } from "./SwiperTypeFour.vue?vue&type=template&id=6fde6fb8&scoped=true&"
import script from "./SwiperTypeFour.vue?vue&type=script&lang=js&"
export * from "./SwiperTypeFour.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTypeFour.vue?vue&type=style&index=0&id=6fde6fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde6fb8",
  null
  
)

export default component.exports